import { createStore } from 'vuex'

import auth from './auth';
import api from './api'

export default createStore({
    state: {
        menuActiveName: '',
        isMinimize: false,
        isProfile: false,
        isMobileMenuOpen: false
    },
    mutations: {
        changeMenu: (state, name) => { state.menuActiveName = name },
        changeMinimize: (state, status) => { state.isMinimize = status },
        changeProfile: (state, status) => { state.isProfile = status },
        toggleMobileMenu: (state) => { state.isMobileMenuOpen = !state.isMobileMenuOpen },
        closeMobileMenu: (state) => { state.isMobileMenuOpen = false }
    },
    modules: {
        auth,
        api
    }
});
